import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/691a8a71decb2500146c656b/pirateers_elite/src/app/institutional-partners/components/InstitutionalPartnersInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/691a8a71decb2500146c656b/pirateers_elite/src/components/common/Header.tsx");
